import { MAP_TYPES } from '@deck.gl/carto';

const COUNTY_BROADBAND_SOURCE_ID = 'countyBroadbandSource';

function source(year) {
  year = parseInt(year);

  return {
    id: COUNTY_BROADBAND_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, broadband, year, geom, geometry.countyname AS name, geometry.statename AS statename, "county" AS type
      FROM
        carto-dw-ac-cn5bemsi.shared.county_observations AS observations
      JOIN
        carto-dw-ac-cn5bemsi.shared.county_geometries AS geometry ON observations.CountyName = geometry.countyname AND observations.StateName = geometry.statename
      WHERE
        observations.year = ${year}
    `,
    queryParameters: {
      year,
    },
  };
}

export default source;
